module.exports = __webpack_public_path__ + "static/media/compress.8565709e.svg";